// earningsDraft keeps the month Earnings is looking at across tab switches:
// the screen unmounts on every switch away, and coming back must not jump
// her back to the current month when she'd navigated to an earlier one.
// A reload or sign-out clears it, and that is fine.
let month: string | null = null

export const earningsDraft = {
  month: () => month,
  saveMonth: (next: string) => {
    month = next
  },
  clearMonth: () => {
    month = null
  },
}
